import { Callout } from '@carouselgg/nexus/callout'
import { MIN_TRUST_TO_COMPETE } from '../dashboard/needsYou'

/**
 * Below the league minimum nothing else on the page matters as much: say so,
 * and point at the steps underneath.
 */
export function LowScoreNotice({ score, subject = 'your score' }: { score: number; subject?: string }) {
  if (score >= MIN_TRUST_TO_COMPETE) return null
  return (
    <Callout variant="info" icon>
      Leagues need a trust score of {MIN_TRUST_TO_COMPETE} to register, and {subject} is {score}.
      The steps below are the quickest way there.
    </Callout>
  )
}
